import React from "react";
import Helmet from 'react-helmet'
import { Link } from "gatsby"
// import { withPrefix } from 'gatsby'
import Layout from "../components/layout";

// Assets
import student from '../assets/images/salena-padilla-flag-marking.jpg';
import marker from '../assets/images/rupture-marking.jpg';

export default () => (
  <React.Fragment>
  <Layout>
    <Helmet>
      <title>Student Geologist Shares Lessons From the Quake Zone</title>
      <body className="student" />
    </Helmet>
    <div className="section hero">
      <div className="wrap">
        <h1>Student Geologist Shares Lessons From the Quake Zone</h1>
        <p>Cal State Fullerton geology major Salena Padilla loves to chase earthquakes. The future scientist, an intern at the Southern California Earthquake Center, teamed up with faculty mentor Sinan Akçiz and other geologists to perform fieldwork in the Mojave Desert following July’s 7.1 magnitude earthquake in Ridgecrest.</p>
      </div>
    </div>

    <div className="wrap">
 
      <div className="inline-image float_right">
        <img src={student} alt="Salena Padilla in the field" />
      </div>
      <h2>Fieldwork is Critical</h2>
      <p>Field observations help scientists confirm if the earthquake has occurred on known or new faults, if it was along a single fault or if it ruptured multiple faults. Scientists measure whether the ground moved along the fault and compare it to other well-documented earthquakes with ruptures.</p>
      <p>“All these data are critical in characterizing earthquakes and building better and safer structures, such as homes, high-rise buildings, and dams and bridges for future earthquakes,” says Padilla.</p>


      <h2>Seismic Pursuit</h2>
      <p>The immersive experience was an opportunity to learn firsthand the process and speed in which it is necessary to react to such major earthquakes and the importance of collecting observational data right away. </p>

      <div className="inline-image float_left">
        <img src={marker} alt="Surface rupture marker" />
      </div>
      
      <p>“It was a fascinating experience to assist Dr. Akçiz and organizations such as the California Geological Survey and the U.S. Geological Survey with their field data collection efforts,” Padilla adds.</p>
 
      <p>“We found that the road near Trona Pinnacles, east of Ridgecrest, was offset nearly 10 inches during the quake. We followed this surface rupture to the north to determine its length and slip magnitude. While there is still so much for me to learn, I am excited because there are so many things we do not know about earthquakes that is waiting to be discovered.”</p>

    </div>
    <div className="bottom-nav">
      <Link to="/mapping/" className="navBtn prev"><span>Go Back to</span>Mapping Quakes</Link>
      <Link to="/alumni/" className="navBtn next"><span>Continue Reading...</span>Geology Alumni</Link>
    </div>
  </Layout>
  </React.Fragment>
);

